import {
  deletePost,
  fetchPosts,
  logPostAction,
  removeUpvote,
  reportPost,
  upvotePost,
} from "./feedApi";
import { canLogPostAction } from "./accountTypes";

export { deletePost, fetchPosts, reportPost, canLogPostAction };

export const likePost = upvotePost;
export const unlikePost = removeUpvote;

export async function fetchUserPosts(userId) {
  if (!userId) return { posts: [], nextCursor: null };

  const postsData = await fetchPosts({
    user_id: userId,
    page: 1,
    page_size: 50,
  });

  const posts = Array.isArray(postsData?.results) ? postsData.results : [];
  // Anonymous posts carry no `user`, so ownership comes from `viewer_is_author`.
  const userPosts = posts.filter((post) => {
    if (post.viewer_is_author) return true;
    const postUserId = post.user?.id || post.user_id;
    return String(postUserId) === String(userId);
  });

  return {
    posts: userPosts,
    nextCursor: null,
  };
}

export async function fetchUserDrafts(userId) {
  if (!userId) return { posts: [], nextCursor: null };

  const postsData = await fetchPosts({
    user_id: userId,
    status: "draft",
    page: 1,
    page_size: 50,
  });

  return {
    posts: Array.isArray(postsData?.results) ? postsData.results : [],
    nextCursor: null,
  };
}

export async function logImpact(post) {
  if (!post?.id) {
    throw new Error("Post is required");
  }
  if (!canLogPostAction(post)) {
    const err = new Error("This post does not have an action type configured");
    err.code = "missing_action_type";
    throw err;
  }

  return logPostAction(post.id, {
    actionType: post.action_type,
    billId: post.bill?.id || post.bill_id,
  });
}
